import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  category: {
    textDecoration: 'none'
  }
})
